import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const Graph = ({ datasets }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');
    // Destroy existing chart instance if it exists
    if (chartInstance.current !== null) {
      chartInstance.current.destroy();
    }

    if(datasets.textLength === undefined){
      
    }

    // Create new chart instance
    chartInstance.current = new Chart(ctx, {
      type: 'bar', // Change to 'bar' for bar chart
      data: {
          labels: [`Password Length - ${datasets.textLength}`], // Single label for independent bars
          datasets: [
            {
              label: 'Colorantí',
              data: [datasets.coloranti], // Replace with actual time for Colorantí
              borderColor: 'rgb(75, 192, 192)',
              backgroundColor: 'blue',
            },
            {
              label: 'SHA-256',
              data: [datasets.sha256], // Replace with actual time for SHA-256
              borderColor: 'rgb(255, 99, 132)',
              backgroundColor: 'red', // Light red
            },
            {
              label: 'BCRYPT',
              data: [datasets.bcrypt], // Replace with actual time for bcrypt
              borderColor: 'rgb(180, 100, 200)',
              backgroundColor: 'green',
            },
            {
              label: 'AES',
              data: [datasets.aes], // Replace with actual time for AES
              borderColor: 'rgb(0, 0, 200)',
              backgroundColor: 'gold',
            },
          ]
      },
      
      options: {
        scales: {
          y: {
            title: { // Ensure 'display' is set to true
              display: true,
              text: 'Password Strength (mins)',
              color: 'black',
              // Set font color to black
              font: {
                color: 'black'
              }
            },
            min: 0, // Adjust as needed
            max: datasets.height,
            ticks: { // Set tick color to black
              color: 'black'
            }
            // Remove beginAtZero: true
          },
          x: { // You can also modify x-axis options similarly
            ticks: {
              color: 'black'
            }
          }
        },
        legend: {
          labels: {
            font: {
              color: 'black'
            },
            color: 'black'
          }
        }
      }
    });

    // Cleanup function to destroy chart instance when component unmounts
    return () => {
      console.log(datasets.coloranti)
      console.log(datasets.sha256)
      console.log(datasets.bcrypt)
      console.log(datasets.aes)
      if (chartInstance.current !== null) {
        chartInstance.current.destroy();
      }
    };
  }, [datasets]);

  return (
    <div className="graph-container">
      <canvas ref={chartRef}></canvas>
    </div>
  );
};

export default Graph;
